import * as Mutations from '@/store/mutation-types'
import { set_one, set_many, ADD_PENDING, ADD_REQUEST, REMOVE_PENDING, REMOVE_REQUEST } from '@/store/mutation-mixins'

export default {

    ADD_PENDING, ADD_REQUEST, REMOVE_PENDING, REMOVE_REQUEST,

    [Mutations.SET_MANY]: set_many({ to: 'entities' }),
    [Mutations.SET_ONE]: set_one({ to: 'entities' }),

}
